import axios from "./axios";
import { API_ERROR_CODE } from "./utils/dataCenter";

const prefix = "/v2/user";

export function updatePhoneNumber(USER_ID: string, PHONE_NUMBER: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(`${prefix}/updatePhoneNumber`, {
        USER_ID,
        PHONE_NUMBER,
      });
      console.log(`${prefix}updatePhoneNumber response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix}updatePhoneNumber error: `, e);
      reject(e);
    }
  });
}

export function get(USER_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ USER_ID });
      const response = await axios.get(
        `${prefix}/get?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} get error: `, e);
      reject(e);
    }
  });
}

export function getUserInfos(USER_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ USER_ID });
      const response = await axios.get(
        `${prefix}/getUserInfos?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getUserInfos error: `, e);
      reject(e);
    }
  });
}

export function getIpAddress() {
  return new Promise(async (resolve, reject) => {
    let ipAddress = "0.0.0.0";
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      console.log(res.data);
      ipAddress = res.data.IPv4;
    } catch (e) {
      console.log(`${prefix} get error: `, e);
    } finally {
      resolve(ipAddress);
    }
  });
}

export function isAgreedUser(USER_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("ID : ", USER_ID);
      const response = await axios.post(`${prefix}/isAgreedUser`, { USER_ID });
      console.log(`${prefix}isAgreedUser response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix}isAgreedUser error: `, e);
      reject(e);
    }
  });
}

export function updateAgreedUser(
  USER_ID: string,
  IS_AGREE_PRIVACYPOLICY: boolean,
  IS_AGREE_TERMSOFSERVICE: boolean
) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("ID : ", USER_ID);
      const response = await axios.post(`${prefix}/updateAgreedUser`, {
        USER_ID,
        IS_AGREE_PRIVACYPOLICY,
        IS_AGREE_TERMSOFSERVICE,
      });
      console.log(`${prefix}updateAgreedUser response: `, response);
      resolve(response);
    } catch (e) {
      console.log(`${prefix}updateAgreedUser error: `, e);
      reject(e);
    }
  });
}

export function getCurrentIp() {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get("/v2/getCurrentIp");
      console.log(res);
      resolve(res);
    } catch (e) {
      console.log(`get getCurrentIp error: `, e);
      reject(e);
    }
  });
}

export function insertUserLog(item: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post("/v2/userLog/insert", { item });
      console.log(res);
      resolve(res);
    } catch (e) {
      console.log(`post insertUserLog error: `, e);
      reject(e);
    }
  });
}
